<template>

</template>

<script>
export default {
    created() {
        if (this.$q.platform.is.android) {
            if (process.env.APP_URL_GOOGLE) {
                window.open(process.env.APP_URL_GOOGLE)
            }

            this.$router.replace({ name: 'login' })
        }
        else if (this.$q.platform.is.ios) {
            if (process.env.APP_URL_APPLE) {
                if (this.$q.platform.is.cordova) {
                    cordova.InAppBrowser.open(process.env.APP_URL_APPLE, '_system', 'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no')
                }
                else {
                    window.open(process.env.APP_URL_APPLE)
                }
            }

            this.$router.replace({ name: 'login' })
        }
        else {
            this.$router.replace({ name: 'login' })
        }
    }
}
</script>

<style>

</style>
